import { Alert, Box, Button, Typography } from '@mui/material';
import { Component, ReactNode } from 'react';


interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  handleReset = () => {
    this.setState({ hasError: false, error: undefined });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <Box sx={{ p: 3 }}>
          <Alert
            severity="error"
            action={
              <Button color="inherit" size="small" onClick={this.handleReset}>
                Riprova
              </Button>
            }
          >
            <Typography variant="body2">
              Qualcosa è andato storto. {this.state.error?.message}
            </Typography>
          </Alert>
        </Box>
      );
    }
    return this.props.children;
  }
}
